import { Component, inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { UserWorkplaceTableStore } from './user-workplace-table.store';
import { TableColumn } from '../../../../shared/components/kit/table/table.types';
import {
    addressColumn,
    nameColumn,
    validFromColumn,
    validToColumn,
} from '../../../../shared/components/kit/table/table.fields';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { AsyncPipe } from '@angular/common';
import { UserWorkplaceIsOpenPipe } from './user-workplace-table.pipes';
import {
    UserWorkplaceUpsertDialogComponent,
} from './user-workplace-upsert-dialog/user-workplace-upsert-dialog.component';
import { translate } from '../../../../shared/shared.global-service';
import { UserWorkplaceObject } from '@libs/types/src/user/object-type/workplace/user-workplace.object';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { GreenOrRedDotComponent } from '../../../../../components/kit/green-or-red-dot/green-or-red-dot.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-user-workplace-table',
    templateUrl: 'user-workplace-table.component.html',
    styleUrl: 'user-workplace-table.component.scss',
    providers: [UserWorkplaceTableStore],
    imports: [
        AsyncPipe,
        UserWorkplaceIsOpenPipe,
        CardTableComponent,
        GreenOrRedDotComponent,
        PrimeTemplate,
    ],
})
export class UserWorkplaceTableComponent implements OnChanges {
    public readonly store = inject(UserWorkplaceTableStore);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly dialogService = inject(BaseDialogService);

    @Input({ required: true }) userId!: string;
    @Input() canEdit = true;
    @ViewChild(TableComponent) table!: TableComponent;

    protected prefix = 'user.workplace.';

    protected columns: TableColumn[] = [
        nameColumn,
        addressColumn,
        {
            name: 'opened',
        },
        validFromColumn,
        validToColumn,
    ];

    protected additionalFilter = [[{
        column: 'userId',
        operator: 'EQ',
        value: [this.userId || ''],
    }]];

    constructor() {
        this.store.registerSuccessMessage('deleteUserWorkplace', 'common.deleted');
        this.store.refreshGrid('getUserWorkplaces', 'createUserWorkplace', 'updateUserWorkplace', 'deleteUserWorkplace');
    }

    public ngOnChanges(_changes: SimpleChanges): void {
        this.additionalFilter = [[{
            column: 'userId',
            operator: 'EQ',
            value: [this.userId || ''],
        }]];
    }

    protected openDialog(item: UserWorkplaceObject | null = null) {
        if (!this.canEdit) return;
        this.dialogService.open(UserWorkplaceUpsertDialogComponent, {
            header: translate.instant('user.workplace.labelMulti'),
            data: {
                userId: this.userId,
                item: item,
            },
        });
    }

    protected delete(event: any): void {
        if (!this.canEdit) return;
        this.confirm.confirm(
            'common.delete',
            null,
            () => this.store.api.deleteUserWorkplace({ id: event.item.id }),
            null,
            'pi-trash',
            event.event.target,
        );
    }
}
